import { useMediaQuery } from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { mobileWidth } from "@qubit/autoparts";
import { useTranslation } from "react-i18next";

import { useAppSelector } from "~/app/store";

import {
  selectHandRaisedForWorkstation,
  selectWorkstationStatus,
  selectGridSystemMode
} from "~/features/andon/andon.selectors";

import { AndonStatus } from "~/features/andon/andon.types";
import { figureAndonColorFromStatus } from "~/features/andon/andon.utils";
import { selectServerConfig } from "~/redux/selectors/appSelectors";
import { selectThisWorkstation } from "~/redux/selectors/workstationsSelectors";

import { RaiseHandButton } from "./RaiseHandButton";

export const WorkstationInformation = () => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery(mobileWidth);

  const { an_andonFeaturesEnabled } = useAppSelector(selectServerConfig);
  const siteWorkstation = useAppSelector(selectThisWorkstation);

  const handRaised = useAppSelector(
    siteWorkstation
      ? selectHandRaisedForWorkstation(siteWorkstation.id)
      : () => undefined
  );
  const workstationStatus = useAppSelector(
    siteWorkstation
      ? selectWorkstationStatus(siteWorkstation.id)
      : () => "good" as AndonStatus
  );
  const gridSystemMode = useAppSelector(
    siteWorkstation
      ? selectGridSystemMode(siteWorkstation.autostoreGridId)
      : () => null
  );

  const calculatedColors = an_andonFeaturesEnabled
    ? figureAndonColorFromStatus({
        handRaised: handRaised?.raised ?? false,
        handRaiseRequestType: handRaised?.requestType,
        workstationStatus,
        workstationActive: siteWorkstation?.status === "Active",
        gridSystemMode: gridSystemMode ?? undefined,
        workstationMode: siteWorkstation?.mode
      })
    : undefined;

  const shouldShowHandButton =
    an_andonFeaturesEnabled && !isMobile && siteWorkstation;
  const shouldShowWorkstationName = siteWorkstation && !isMobile;

  if (!shouldShowHandButton && !shouldShowWorkstationName) {
    return null;
  }

  return (
    <>
      {shouldShowHandButton && <RaiseHandButton />}

      {shouldShowWorkstationName && (
        <Box
          role="region"
          sx={{
            display: "flex",
            justifyContent: "center",
            backgroundColor: calculatedColors?.backgroundColor,
            borderRadius: 1
          }}
        >
          <Typography
            sx={{
              margin: "5px",
              color: calculatedColors?.textColor
            }}
          >
            {t("nav.viewname.workstation")}: {siteWorkstation.deviceId}
          </Typography>
        </Box>
      )}
    </>
  );
};
